export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const SAVE_ACCOUNT = 'SAVE_ACCOUNT';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const UPDATE_ACCOUNTS_LIST = 'UPDATE_ACCOUNTS_LIST';
